'use client';

import type { GroupEventSearchItem } from '@ps/api/types';
import { Button } from '@ps/ui/atoms/button';
import { ChevronRight } from 'lucide-react';

import { formatEventCardDateTime } from '../utils/format';

// ─── Component ─────────────────────────────────────────────────────────────

interface EventCardProps {
  event: GroupEventSearchItem;
  onClick: () => void;
}

export function EventCard({ event, onClick }: EventCardProps) {
  const dateTimeLabel = formatEventCardDateTime(event.startDate, event.endDate);

  return (
    <Button
      variant="ghost"
      onClick={onClick}
      className="flex h-auto w-full items-center justify-between overflow-hidden rounded-[16px] border border-gray-200 bg-gray-50 p-4 text-left transition-colors hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700"
    >
      <div className="flex min-w-0 flex-col gap-1">
        <p className="truncate text-sm font-medium text-gray-900 dark:text-white">
          {dateTimeLabel}
        </p>
        <p className="truncate text-xs font-light text-gray-500 dark:text-gray-400">
          {event.name}
        </p>
      </div>
      <ChevronRight className="ml-3 h-5 w-5 flex-shrink-0 rotate-90 text-gray-400 dark:text-gray-500" />
    </Button>
  );
}
